import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';
import { useWeekendDetection } from '../../hooks/useWeekendDetection';

interface WeekendCampaignBannerProps {
  isBannerVisible: boolean;
  isMobileView: boolean;
}

export function WeekendCampaignBanner({ isBannerVisible, isMobileView }: WeekendCampaignBannerProps) {
  // Check if weekend feature is enabled
  const weekendFreeEnabled = process.env.REACT_APP_WEEKEND_FREE_ENABLED === 'true';
  
  // Use the weekend detection hook instead of local state
  const { isWeekend, timeLeft } = useWeekendDetection();

  if(!weekendFreeEnabled || !isWeekend) return null;
  return (
    <div
      className={`fixed top-20 left-1/2 -translate-x-1/2 z-9 w-[calc(100%-2rem)] w-full transition-opacity duration-1000 ${isBannerVisible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
      style={{ transitionDuration: '600ms' }}
    >
      <div
        className={`
          relative overflow-hidden border backdrop-blur-md px-2
          ${isWeekend
            ? 'bg-gradient-to-r from-primary-light via-secondary-light to-primary-light dark:from-primary-dark dark:via-secondary-dark dark:to-primary-dark animate-gradient bg-[length:200%_auto] border-white/20 dark:border-white/10'
            : 'bg-primary-light dark:bg-primary-dark border-primary-light/20 dark:border-primary-dark/20'}
          shadow-lg
          transition-all duration-700
        `}
        style={{ transformOrigin: 'center' }}
      >
        {/* Shine effect for weekend state */}
        {isWeekend && (
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shine" />
        )}
        <div className="relative flex flex-row items-center justify-center text-center px-2 md:px-4 py-2.5 w-full">
          <div
            className={`flex flex-row  items-center gap-2 w-full justify-center transition-opacity duration-500 opacity-100`}
          >
            {!isMobileView && <span className="text-xs md:text-sm font-bold text-white">#FreeMockWeekends -</span>}
            {isWeekend && !isMobileView && (
              <span className="text-xs md:text-sm font-bold text-white -ml-1">
                It's Weekend,
              </span>
            )}
            <span className="text-sm md:text-sm font-medium text-white -ml-1">
              MockTrail is <span className="font-heading font-bold">100% FREE</span> To Practice on Every Saturday & Sunday. Start your practice!
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}